import { type Filters } from '~/ui/molecules/FilterGroups';

export const emptyDeliveryNoteFilterGroup: Filters = {
  selectedAcceptState: [],
  selectedArticle: [],
  selectedArticleNumber: [],
  selectedCategory: [],
  selectedCostCenter: [],
  selectedCustomerNumber: [],
  selectedCustomFields: [],
  selectedFromSite: [],
  selectedOuId: [],
  selectedPermittedCostCenters: [],
  selectedPermittedToSites: [],
  selectedProcessState: [],
  selectedRecipient: [],
  selectedSettledStatus: [],
  selectedSource: [],
  selectedSubmittedByUserId: [],
  selectedSupplier: [],
  selectedToSiteRecipient: [],
  selectedToSiteSupplier: [],
};
